import React from 'react';
import legaleyseLogoImg from '../../shared/images/legaleyse-logo-img.svg';
import legaleyseLogoTxt from '../../shared/images/legaleyse-logo-txt.svg';

function Logo() {
    return (
        <div className="logo">
            <div className="image-wrapper">
                <img alt={'Logo'} src={legaleyseLogoImg} className={'image'} />
            </div>
            <img alt={'Logo'} src={legaleyseLogoTxt} className={'text'} />
        </div>
    );
}

export default Logo;
